import type { FC } from "react";
import styled from "@emotion/styled";
import { ChevronLeft, X } from "lucide-react";
import { colors, spacing } from "../design-tokens";
import { H3 } from "./typographies";
import { ActionButton } from "./action-button";

export type ModalHeaderProps = {
  title: string;
  onBackClick?: () => void;
  onCloseClick?: () => void;
  isMultiModal?: boolean;
};

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.md}px;
`;

const HeaderTitle = styled(H3)`
  color: ${colors.primary};
`;

export const ModalHeader: FC<ModalHeaderProps> = ({
  title,
  onBackClick,
  onCloseClick,
  isMultiModal = false,
}) => {
  return (
    <Header>
      <LeftSection>
        {isMultiModal && onBackClick && (
          <ActionButton onClick={onBackClick} aria-label="Go back" variant="ghost" size="small">
            <ChevronLeft size={20} color={colors.neutralGrey} />
          </ActionButton>
        )}
        <HeaderTitle>{title}</HeaderTitle>
      </LeftSection>

      {!isMultiModal && onCloseClick && (
        <ActionButton onClick={onCloseClick} aria-label="Close modal" variant="ghost" size="small">
          <X size={20} color={colors.neutralGrey} />
        </ActionButton>
      )}
    </Header>
  );
};
